<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "host-activity",
        data() {
            return {
            }
        },
    }
</script>

<style lang="scss" scoped>
</style>
